import { useMsal } from '@azure/msal-react';
import { Bell, LogOut } from 'lucide-react';
import Button from '../ui/Button';
import { getInitials } from '@/lib/utils';

export default function Header() {
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  const account = accounts[0];
  const displayName = account?.name || account?.username || 'User';
  const initials = getInitials(displayName);

  return (
    <header className="flex h-16 items-center justify-between border-b border-neutral-200 bg-white px-6">
      {/* Left side - could add breadcrumbs or search */}
      <div className="flex items-center gap-4">
        <h2 className="text-lg font-semibold text-neutral-900">
          {/* This will be dynamic based on route */}
        </h2>
      </div>

      {/* Right side - notifications and user menu */}
      <div className="flex items-center gap-4">
        {/* Notifications */}
        <button
          className="relative rounded-md p-2 hover:bg-neutral-100"
          title="Notifications"
        >
          <Bell className="h-5 w-5 text-neutral-600" />
          {/* Badge for unread notifications */}
          <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-red-500" />
        </button>

        {/* User menu */}
        <div className="flex items-center gap-3">
          <div className="text-right">
            <p className="text-sm font-medium text-neutral-900">{displayName}</p>
            <p className="text-xs text-neutral-600">{account?.username}</p>
          </div>

          {/* Avatar */}
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-sm font-semibold text-primary-700">
            {initials}
          </div>

          {/* Logout button */}
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            title="Sign out"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
